import { IComment } from "projects/models/src/public-api";
import { Observable } from "rxjs";

export abstract class NgCommentService {
  abstract getCommentsCountByPostId(postId: number): Observable<number>;
  abstract getCommentsByPostId(postId: number, page?: number, per_page?: number, parent?: number): Observable<IComment[]>;
  abstract createComment(postId: number, comment: IComment): Observable<void>;
  abstract updateComment(commentId: number, comment: IComment): Observable<void>;
  abstract deleteComment(commentId: number): Observable<void>;
}
